import { PricingEshopProductMargins } from './pricingMarginsTypes';

// eslint-disable-next-line import/prefer-default-export
export const mockPricingEshopProductMargins: PricingEshopProductMargins = {
  marketplaceCode: 'ALLEGRO.PL',
  partnerProductCode: 'SKU-1',
  partnerRelativeDemandedMinimumMargin: 12.345,
  partnerRegularMarginAbs: 135.52,
};
